import { render, staticRenderFns } from "./detailComplaintInstantClaim.vue?vue&type=template&id=b24cb74c&"
import script from "./detailComplaintInstantClaim.vue?vue&type=script&lang=js&"
export * from "./detailComplaintInstantClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports